import { render } from "./Tracking.vue?vue&type=template&id=3b1fe4ef&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"

import "./Tracking.vue?vue&type=style&index=0&id=3b1fe4ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b1fe4ef"

export default script